import React from 'react';

import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import {apiIdToIconName} from 'util/APIUtil';

import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export default function DocumentChip(props: SharedSmartChipProps<SmartChipType.DOCUMENT>): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: document,
    handleClickLink,
    isInaccessible,
    itemUrl: documentUrl,
  } = useSmartChipQuery<SmartChipType.DOCUMENT>({
    id,
    onClick,
    getUrlFn: ({editUrl}) => editUrl,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={document != null ? apiIdToIconName(document.id) : null}
      isInaccessible={isInaccessible}
      item={document}
      onClick={handleClickLink}
      url={documentUrl}
    />
  );
}
